import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-700 font-light bg-gray-100" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "pl-2 pb-2 font-bold text-red-500 hover:text-red-400" }
const _hoisted_4 = { class: "md:flex mb-2" }
const _hoisted_5 = { class: "pb-1" }
const _hoisted_6 = { class: "md:border-r border-gray-300 px-2 hover:text-gray-500" }
const _hoisted_7 = { class: "pb-1" }
const _hoisted_8 = { class: "md:border-r border-gray-300 px-2 hover:text-gray-500" }
const _hoisted_9 = { class: "pl-2 hover:text-gray-500" }
const _hoisted_10 = { class: "pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layouts_auth_width, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: "/recommend" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("あなたにおすすめの講座", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, { to: "/contact" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('contact.title')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/terms" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("ご利用規約", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_router_link, { to: "/account" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('word.setting')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, " © " + _toDisplayString(new Date().getFullYear()) + " ウイニングクルー株式会社 ", 1)
        ])
      ]),
      _: 1
    })
  ]))
}